export default __webpack_public_path__ + "static/media/our-partner-new-1.537857f5.jpg";